import {FC} from "react";
import {TabColumn} from "../../../tab-content";
import {useOperationalEntity} from "../../context";
import {TenantPanel} from "./TenantPanel";
import {TenantSiblingsTable} from "./TenantSiblingsTable";

export const OperationalTenancyColumn: FC = () => {
  const {
    entity: {id, tenantId}
  } = useOperationalEntity();

  return (
    <TabColumn name={"tenancy-column"}>
      <TenantPanel entityId={id} tenantId={tenantId ?? undefined} />
      <TenantSiblingsTable currentEntityId={id} tenantId={tenantId ?? undefined} />
    </TabColumn>
  );
};
